import { defineComponent as _defineComponent } from 'vue';
import { ref, onMounted, getCurrentInstance } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'popover',
    props: {
        text: null
    },
    setup(__props) {
        const props = __props;
        const { proxy: curInstance } = getCurrentInstance();
        const tipsPosition = {
            left: -999,
            top: -999,
        };
        const popover = ref(null);
        // 计算提示气泡的位置
        onMounted(() => {
            // console.log('==offsetHeight', popover.value?.offsetHeight, popover.value?.offsetWidth);
            const childList = curInstance.$slots.default;
            const popoverWidth = popover.value.offsetWidth;
            const popoverHeight = popover.value.offsetHeight;
            isShow.value = false;
            if (childList) {
                let top = 0;
                let height = 0;
                let left = 0;
                for (let i = 0; i < childList.length; i++) {
                    const element = childList[i].elm;
                    // console.log('=tipsPosition', element);
                    if (i === 0) {
                        top = element.offsetTop;
                    }
                    if (left < element.offsetLeft) {
                        left = element.offsetLeft;
                    }
                    height += element.offsetHeight;
                }
                tipsPosition.top = top + (height - popoverHeight) / 2;
                tipsPosition.left = left - popoverWidth / 2;
                // console.log('===popover', tipsPosition, height, popoverHeight, top, left);
            }
        });
        const isShow = ref(true);
        function onMouseenter() {
            isShow.value = true;
        }
        function onMouseleave() {
            isShow.value = false;
        }
        return { __sfc: true, props, curInstance, tipsPosition, popover, isShow, onMouseenter, onMouseleave };
    }
});
